import { getSdk } from "../../services/sdkService";
import { i18n } from "../../services/i18nService";
import { getErrorCode } from "../../errors/codes";
import { config } from "../../config/config";
import { getAppState } from "../../state";

export async function getDevices() {
  const sdk = await getSdk();
  try {
    const response = await sdk.userManager.getDevices({ avoidCache: true });
    return response;
  } catch (e) {
    return e;
  }
}

export async function checkDevice() {
  const sdk = await getSdk();
  const checkResult = (await sdk.userManager.checkDeviceCanPlay()) || {};
  if (checkResult && checkResult.freeDeviceSlotsExist && !checkResult.deviceAlreadyRegistered) {
    // If the device is not registered, try to register it regardless the list is full or not
    try {
      await addDevice.call(this, checkResult.deviceId);
    } catch (e) {
      // FIXME If I'm not wrong, the SDK won't return e.reason anymore but codes instead. Please review.
      if (e.reason === "timeout") {
        e.message = i18n.get("global.errors.timeout.text");
        const code = getErrorCode("loadTimeoutError");
        sdk.reportsManager.sendReport(
          { level: "error", event: "Playback", env: process.env.NODE_ENV },
          {
            eventId: "PlayerError",
            report: code,
            status: "error",
            parameter: {
              errorCode: code,
              dump: {
                timedOutCall: "addDevice"
              }
            }
          }
        );
      } else if (e.error_code === "34003") {
        // checking device limit reached error and showing popup accordingly
        checkResult.freeDeviceSlotsExist = false;
      } else {
        if (
          !checkResult.freeDeviceSlotsExist ||
          e.code === sdk.userManager.userErrorCodes.MAX_AMOUNT_OF_DEVICES_REACHED
        ) {
          // If adding the device failed and the check reported there were no free device slots, return the original
          // check result so that the scenario is treated as a 'full devices list' case, instead of a 'device addition
          // failure'
          return checkResult;
        } else {
          throw e;
        }
      }
    }
  }
  return checkResult;
}

async function addDevice(deviceId) {
  const sdk = await getSdk();
  const model = await sdk.systemManager.device.getModel();
  try {
    await sdk.userManager.addDevice({
      type: config.get().sdk.deviceType,
      name: `${config.get().sdk.deviceName} - ${deviceId}`,
      description: `${config.get().sdk.deviceName} - ${model}`,
      clientIdentifiers: {
        WMDRM: deviceId
      }
    });
  } catch (e) {
    // TODO: Investigate async try-catch flows, to see if it's possible to avoid scaling/bubbling new Error up in the try-catch chain.
    throw e;
  }
}

/**
 * Sends an error report when maximum devices quantity has been reached.
 */
export async function sendMaxDevicesReport() {
  const sdk = await getSdk();
  sdk.playerManager.stop();
  sdk.playerManager.destroy();
  const code = getErrorCode("maxDevicesError");
  await sdk.reportsManager.sendReport(
    { level: "error", event: "Playback", env: process.env.NODE_ENV },
    {
      eventId: "PlayerError",
      report: code,
      status: "error",
      parameter: {
        errorCode: code,
        playbackInfo: {
          titleId: this.config.id,
          manifestUrl: this.config.manifest,
          releasePid: this.config.releasePids && this.config.releasePids[0],
          releaseUrl: this.config.releaseUrl,
          quality: this.config.playbackAnalytics.is4KEnabled,
          playerErrorDump: {
            trace: "Maximum devices quantity reached",
            placeInCode: "APP - devices.js"
          }
        }
      }
    }
  );
}

export async function removeDevice(deviceId) {
  const sdk = await getSdk();
  try {
    await sdk.userManager.deleteDevice(deviceId);
  } catch (e) {
    return e.error_code;
  }
}
